import { useTranslation } from "react-i18next";
import * as yup from "yup";
import useTicketValidationSchema from "./useTicketValidationSchema";

function useTicketsValidation() {
  const { t } = useTranslation("validationsSchema");
  const ticketValidationSchema = useTicketValidationSchema();

  const schema = yup
    .array()
    .min(1, t("atLeastOneTicketRequired"))
    .of(ticketValidationSchema)
    .test("promo-code-pair", t("promoCodeNameAndDiscountDependency"), function (tickets) {
      return tickets.every((ticket) => {
        const { promoCodeName, promoCodeDiscount } = ticket;
        const oneFilled = promoCodeName || promoCodeDiscount;
        const bothFilled = promoCodeName && promoCodeDiscount;
        return !oneFilled || bothFilled;
      });
    });

  return schema;
}

export default useTicketsValidation;
